<div class="common-layout {{ 'is-' + selectedHeaderColor }}" [ngClass]="{
        'is-folded': isFolded,
        'is-side-nav-dark' : isSideNavDark,
        'is-expand' : isExpand
    }">
    <app-header></app-header>
    <app-sidenav></app-sidenav>
    <div class="page-container">
        <div class="main-content">
            <div class="main-content-header ml-3" *ngIf="contentHeaderDisplay !== 'none'">
                <nz-icon nzType="home" nzTheme="outline"/>
                <nz-breadcrumb nzSeparator=">">
                    <nz-icon nzType="right" nzTheme="outline" (click)="back()"/>
                    <nz-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs$ | async">
                        <a [routerLink]="breadcrumb.url">
                            {{ breadcrumb.label }}
                        </a>
                    </nz-breadcrumb-item>
                </nz-breadcrumb>
            </div>
            <!-- <nz-page-header class="page-header" [nzTitle]="header" *ngIf="header"></nz-page-header> -->
            <router-outlet></router-outlet>
            <router-outlet name="popup"></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
</div>